import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading } from "capitalrx-components-2.0/lib/typography";
import { Breadcrumbs, PageLayout } from "@/premium/themedComponents";

export const ComparePlansPage = () => {
  return (
    <PageLayout showGradient={false}>
      <Stack>
        <Stack spacing="small">
          <Breadcrumbs />
          <Heading>Compare Plans</Heading>
          <Body>Placeholder for Compare plans page for creation of menubar. Thanks!</Body>
        </Stack>
      </Stack>
    </PageLayout>
  );
};
